<svelte:options accessors/>
<script>
    import NauiFloatingAction from "../../naui/components/NauiFloatingAction.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import ServicioEquipoItem from "./ServicioEquipoItem.svelte";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let cargos = [];
    export let placas = [];

    export let columnsTeam = [
        {
            label: 'Cargo',
            slug: 'position',
            options: cargos
        },
        {
            label: 'Nombre',
            slug: 'name'
        },
    ];
    export let dataTeam = [
        {
            name: '',
            position: ''
        }
    ];
    export let columnsTruck = [
        {
            label: 'Placa',
            slug: 'placa',
            options: placas
        }
    ];
    export let dataTruck = [];

    function save() {
        console.log(dataTeam);
        dispatch('save', {
            team: dataTeam.map((item, i) => {
                return {
                    i: i + 1,
                    ...item
                }
            }),
            trucks: dataTruck.map((item, i) => {
                return {
                    i: i + 1,
                    ...item
                }
            })
        });
    }
</script>
<div class="py-2">
    <ServicioEquipoItem title="Equipo a cargo del servicio"
                        columns={columnsTeam}
                        bind:items={dataTeam}/>
    <ServicioEquipoItem title="Camiones"
                        columns={columnsTruck}
                        bind:items={dataTruck}
                        canZero={true}/>
</div>

<NauiFloatingAction>
    <NauiButton caption="GUARDAR"
                icon="save"
                color="accent"
                mode="solid"
                on:click={save}/>
</NauiFloatingAction>

